module.exports = __webpack_public_path__ + "static/media/mq.2eb10a3e.svg";